module.exports = __webpack_public_path__ + "img/smart-contracts.c0a9e044.png";